import Sidebar from "../../sidebar";
import {
  Formik,
  Form,
  Field,
  ErrorMessage,
  getIn,
  FormikHelpers,
} from "formik";
import * as Yup from "yup";
import Toggle from "react-toggle";
import "react-toggle/style.css";
import FormInput from "../../../../components/FormInput";
import { useEffect, useState } from "react";
import { addUser, getUser, updateUser } from "./form-section.service";
import toast from "react-hot-toast";
import { useLocation, useNavigate, useParams } from "react-router-dom";

const validationSchema = Yup.object({
  firstName: Yup.string().required("First Name is required."),
  lastName: Yup.string().required("Last Name is required."),
  username: Yup.string().required("Username is required."),
  password: Yup.string()
    .required("Password is required.")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
      "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
    ),
  confirmPassword: Yup.string()
    .required("Confirm password is required.")
    .oneOf([Yup.ref("password"), ""], "Passwords must match"),
  isShowPersonalizedProducts: Yup.boolean(),
  isShowSample: Yup.boolean(),
  isMultiFactorAuthenticationEnabled: Yup.boolean(),
});

const validationEditModeSchema = Yup.object({
  firstName: Yup.string().required("First Name is required."),
  lastName: Yup.string().required("Last Name is required."),
  username: Yup.string().required("Username is required."),
  password: Yup.string().matches(
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
    "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
  ),
  confirmPassword: Yup.string().oneOf(
    [Yup.ref("password"), ""],
    "Passwords must match"
  ),
});

export default function FormSection({ isEdit }: { isEdit: boolean }) {
  const [user, setUser] = useState<any>();
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();
  const param = useParams();

  const handleSubmit = (values: any, actions: FormikHelpers<any>) => {
    let data = {
      ...values,
    };
    delete data.confirmPassword;
    if (isEdit) {
      if (data.password === "") {
        delete data.password;
        delete data.confirmPassword;
      }

      updateUser(param.id as string, data)
        .then((response) => {
          toast.success("User updated successfully");
          navigate("/admin/users");
        })
        .catch((error) => {
          toast.error(error.response.data.message);
        })
        .finally(() => {
          actions.setSubmitting(false);
        });
      return;
    }
    addUser(values)
      .then((response) => {
        toast.success("User added successfully");
        navigate("/admin/users");
      })
      .catch((error) => {
        toast.error(error.response.data.message);
      })
      .finally(() => {
        actions.setSubmitting(false);
      });
  };

  useEffect(() => {
    if (isEdit) {
      console.log("Param:", param.id);
      getUser(param.id as string).then((response) => {
        setUser(response.data);
        setLoading(false);
      });
    } else {
      setLoading(false);
    }
  }, []);

  return (
    <section className="ec-page-content ec-vendor-dashboard section-space-p">
      <div className="container">
        <div className="row">
          <Sidebar />
          <div className="ec-shop-rightside col-lg-9 col-md-12">
            <div className="ec-vendor-dashboard-card space-bottom-30">
              <div className="ec-vendor-card-header">
                <h5>Add User</h5>
              </div>
              <div className="ec-vendor-card-body">
                {loading ? (
                  "Loading..."
                ) : (
                  <Formik
                    initialValues={{
                      firstName: user ? user.firstName : "",
                      lastName: user ? user.lastName : "",
                      username: user ? user.username : "",
                      password: user ? "" : "",
                      confirmPassword: user ? "" : "",
                      isShowPersonalizedProducts: user
                        ? user.isShowPersonalizedProducts
                        : false,
                      isShowSample: user ? user.isShowSample : false,
                      isMultiFactorAuthenticationEnabled: user
                        ? user.isMultiFactorAuthenticationEnabled
                        : false,
                    }}
                    validationSchema={
                      isEdit ? validationEditModeSchema : validationSchema
                    }
                    onSubmit={handleSubmit}
                  >
                    {({
                      isSubmitting,
                      values,
                      errors,
                      touched,
                      setFieldValue,
                      handleChange,
                    }) => (
                      <Form>
                        <div className="row">
                          <div className="col-lg-6">
                            <FormInput
                              name="firstName"
                              type={"text"}
                              onChange={handleChange}
                              placeholder={"First Name"}
                              label={"First Name"}
                              isRequired={true}
                              error={getIn(errors, "firstName")}
                              className={""}
                              touched={getIn(touched, "firstName")}
                              value={values.firstName}
                            />
                          </div>
                          <div className="col-lg-6">
                            <FormInput
                              name="lastName"
                              type={"text"}
                              onChange={handleChange}
                              placeholder={"Last Name"}
                              label={"Last Name"}
                              isRequired={true}
                              error={getIn(errors, "lastName")}
                              className={""}
                              touched={getIn(touched, "lastName")}
                              value={values.lastName}
                            />
                          </div>
                          <div className="col-lg-6">
                            <FormInput
                              name="username"
                              type={"text"}
                              onChange={handleChange}
                              placeholder={"Username"}
                              label={"Username"}
                              isRequired={true}
                              error={getIn(errors, "username")}
                              className={""}
                              touched={getIn(touched, "username")}
                              value={values.username}
                            />
                          </div>

                          <div className="col-lg-6">
                            <FormInput
                              name="password"
                              type={"password"}
                              onChange={handleChange}
                              placeholder={"Password"}
                              label={"Password"}
                              isRequired={true}
                              error={getIn(errors, "password")}
                              className={""}
                              touched={getIn(touched, "password")}
                              value={values.password}
                            />
                          </div>
                          <div className="col-lg-6">
                            <FormInput
                              name="confirmPassword"
                              type={"password"}
                              onChange={handleChange}
                              placeholder={"Confirm Password"}
                              label={"Confirm Password"}
                              isRequired={true}
                              error={getIn(errors, "confirmPassword")}
                              className={""}
                              touched={getIn(touched, "confirmPassword")}
                              value={values.confirmPassword}
                            />
                          </div>
                          <div className="col-lg-2">
                            <div className="default-form-box d-flex flex-column">
                              <label
                                style={{
                                  fontSize: "small",
                                }}
                              >
                                Show personalized
                              </label>
                              <Toggle
                                name={`isShowPersonalizedProducts`}
                                defaultChecked={
                                  values.isShowPersonalizedProducts
                                }
                                value={values.isShowPersonalizedProducts as any}
                                icons={false}
                                onChange={(event) => {
                                  setFieldValue(
                                    `isShowPersonalizedProducts`,
                                    event.target.checked
                                  );
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-lg-2">
                            <div className="default-form-box d-flex flex-column">
                              <label
                                style={{
                                  fontSize: "small",
                                }}
                              >
                                Show Sample
                              </label>
                              <Toggle
                                name={`isShowSample`}
                                defaultChecked={values.isShowSample}
                                value={values.isShowSample as any}
                                icons={false}
                                onChange={(event) => {
                                  setFieldValue(
                                    `isShowSample`,
                                    event.target.checked
                                  );
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-lg-2">
                            <div className="default-form-box d-flex flex-column">
                              <label
                                style={{
                                  fontSize: "small",
                                }}
                              >
                                MFA
                              </label>
                              <Toggle
                                name={`isMultiFactorAuthenticationEnabled`}
                                defaultChecked={
                                  values.isMultiFactorAuthenticationEnabled
                                }
                                value={
                                  values.isMultiFactorAuthenticationEnabled as any
                                }
                                icons={false}
                                onChange={(event) => {
                                  setFieldValue(
                                    `isMultiFactorAuthenticationEnabled`,
                                    event.target.checked
                                  );
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-lg-12">
                            <div className="text-right">
                              <button
                                type="submit"
                                className="btn btn-primary mr-1"
                                //   disabled={isSubmitting}
                              >
                                {isSubmitting
                                  ? isEdit
                                    ? "Updating User..."
                                    : "Adding User..."
                                  : isEdit
                                  ? "Update User"
                                  : "Add User"}
                              </button>
                            </div>
                          </div>
                        </div>
                      </Form>
                    )}
                  </Formik>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
